// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BlogManagement-commonHeaderAdmin-cg6N1 {
	position: fixed !important;
}

.BlogManagement-adminLayout-rsfF2 {
	padding-top: 64px !important;
}

.BlogManagement-box-dmdhz h2 {
	font-size: 21px;
	font-weight: 600;
}

.BlogManagement-exportLink-D252l {
	margin-bottom: -29px;
}

.BlogManagement-blockCenter-Vstan {
	float: none !important;
	display: block;
	margin: 0 auto;
	margin-top: 30px;
}

.BlogManagement-panelHeader-g7qhx {
	padding-bottom: 18px !important;
	padding: 24px 15px;
	border-radius: 6px !important;
	border: 1px solid var(--primary-border)
}

.BlogManagement-currencyselect-ae6MZ {
	width: 100%;
	margin-right: 0px;
}

.BlogManagement-panelHeader-g7qhx {
	overflow: hidden;
	position: relative;
}

.BlogManagement-mar0-ZKXQO {
	margin-left: 0;
	margin-right: 0;
}

@media screen and (max-width: 767px) {
	.BlogManagement-blockCenter-Vstan {
		padding: 0px;
	}

	.BlogManagement-panelHeader-g7qhx {
		padding: 24px 5px;
	}
}

/** Admin - Common - Start **/

.BlogManagement-sideAdminPageWrapper-iXdOf {
	margin-left: var(--siteAdmin-sideBar-width);
	position: relative;
	padding: calc(var(--siteAdmin-header-height) + 28px) 25px 120px;
}

.BlogManagement-panelHeader-g7qhx {
	border-radius: 0;
	width: 100%;
	display: block;
	font-size: 16px;
	padding-bottom: 12px;
	border-bottom: 1px solid var(--primary-border);
	background-color: var(--background-primary);
}

.BlogManagement-table-S4ka6 {
	display: table;
}

.BlogManagement-tableRow-zByaq {
	display: table-row;
}

.BlogManagement-tableCell-L1TW7 {
	display: table-cell;
	float: none;
}

.BlogManagement-formGroup-Eqk87 {
	margin-bottom: 6px;
}

.BlogManagement-select-j6p5E {
	position: relative;
	display: inline-block;
	vertical-align: bottom;
	margin-right: 5px;
}

.BlogManagement-noMargin-PKzzq {
	margin: 0px;
}

a,
a:hover {
	cursor: pointer;
}

.BlogManagement-exportLink-D252l {
	padding-top: 10px;
	padding-right: 10px;
}

.BlogManagement-labelTextNew-fZLEj {
	font-size: 16px;
	line-height: 24px;
	font-weight: 600;
	margin: 0 0 6px;
	text-align: start;
	color: var(--primary-foreground);
}

.BlogManagement-displayInline-v5VwX {
	display: inline-block;
}

/******************* Admin Modal ListSetting Start *******************/

.BlogManagement-btnUPdate-TUFq1 {
	display: inline-block;
}

.BlogManagement-btnModalDelete-OI4Yb {
	display: inline-block;
	margin-left: 15px;
}

.BlogManagement-radioBtn-m_0S3 {
	position: relative;
	top: 1px;
	vertical-align: middle;
}

.BlogManagement-backgroundImg-ewwsT {
	padding-top: 80%;
	background-position: top center;
	background-size: cover;
}

@media screen and (max-width: 767px) {
	.BlogManagement-btnUPdate-TUFq1 {
		display: block;
		margin-bottom: 12px;
	}

	.BlogManagement-btnModalDelete-OI4Yb {
		display: block;
		margin-left: 0px;
	}

	.BlogManagement-btnWidth-e3cTO {
		width: 100%;
	}
}

/******************* Admin Modal ListSetting Start *******************/

/******************* Admin Banner Image Section Start ****************/

.BlogManagement-bannerImageBg-UmfJG {
	padding-top: 60%;
	background-repeat: no-repeat;
	background-size: contain;
	border-radius: 4px;
	background-position: center;
	background-color: var(--secondary-gray-bg);
	border: 1px dashed var(--primary-border);
}

.BlogManagement-bannerDelete-Bw3hY {
	position: absolute;
	top: -12px;
	right: 4px;
}

/*******************Admin Modal Start **********************/

.BlogManagement-modalRoot-aEmvV {
	padding: 32px;
}

.BlogManagement-modalBorderBottom-AsyGm {
	border-bottom: 5px solid var(--primary-bg);
	border-bottom-left-radius: 14px;
	border-bottom-right-radius: 14px;
}

.BlogManagement-logInModalBody-bLt3w {
	padding: 0px;
}

/*************** Admin TableNew Design Start**************************/

.BlogManagement-exportSection-lgEAS {
	background: #f5f5f5;
	padding: 24px 15px;
	display: grid;
	grid-template-columns: 28% 15% 55%;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	grid-gap: 11px;
	border-top-left-radius: 6px;
	border-top-right-radius: 6px;
	border: 1px solid var(--primary-border);
	border-bottom: 0;
}

.BlogManagement-exportSectionGridSub-bXJ7G {
	grid-template-columns: 50% 49% !important;
}

.BlogManagement-exportText-e7WzP {
	color: var(--primary-foreground) !important;
	text-decoration: none !important;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 12px;
}

.BlogManagement-exportLinkImg-CTWoA {
	background: var(--common-white-primary-bg);
	padding: 10px;
	border-radius: 4px;
	display: inline-block;
}

.BlogManagement-vtrMiddle-GjkL2 {
	vertical-align: middle;
}

.BlogManagement-exportImg-ChsSB {
	width: 100%;
	max-width: 16px;
	vertical-align: middle;
}

.BlogManagement-profileViewlabel-QKdfo {
	display: inline-block;
	width: 38%
}

.BlogManagement-profileViewMainContent-aMtP9 {
	display: inline-block;
	width: 62%;
}

.BlogManagement-profileViewMain-PjaA6 {
	border: 1px solid var(--primary-border);
	border-radius: 6px;
}

.BlogManagement-profileViewInner-HS_Qv {
	padding: 10px;
	border-bottom: 1px solid var(--primary-border);
}

.BlogManagement-profileImageSection-hc6fg {
	width: 100%;
	height: 100px;
	max-width: 100px;
	max-height: 100px;
	border-radius: 50%;
}

.BlogManagement-lastviewInner-Q5528 {
	padding: 10px;
}

.BlogManagement-whyHostHoriLine-ewnKq {
	margin: 30px 0;
}

.BlogManagement-tableGrid-a7b4d {
	display: grid;
	grid-template-columns: 50% 50%;
	-webkit-column-gap: 10px;
	   -moz-column-gap: 10px;
	        column-gap: 10px;
	word-wrap: break-word;
}

.BlogManagement-headingContent-Uwkmv {
	font-size: 18px;
	font-weight: 500;
}

.BlogManagement-refundTextColor-YbtVa {
	color: var(--alert-color);
	font-size: 18px;
	text-decoration: line-through;
	text-decoration-thickness: 2px;
	text-decoration-color: var(--black-color);
}

.BlogManagement-dividerLine-P7UFL {
	border-top: 1px solid var(--primary-border);
	margin: 30px 0;
}

.BlogManagement-smallContent-inHtx {
	font-size: 14px;
	margin-top: 6px;
	color: var(--secondary-foreground);
}

@media (max-width: 1200px) and (min-width: 1024px) {
	.BlogManagement-sideAdminPageWrapper-iXdOf {
		height: 100%;
		overflow: auto;
	}
}

@media (max-width:1199px) {
	.BlogManagement-sideAdminPageWrapper-iXdOf {
		margin-left: 0;
	}
}

@media screen and (max-width: 991px) {
	.BlogManagement-exportSection-lgEAS {
		grid-template-columns: 100%;
	}

	.BlogManagement-exportSectionGridSub-bXJ7G {
		grid-template-columns: 100% !important;
	}

}

@media screen and (max-width: 767px) {
	.BlogManagement-profileViewlabel-QKdfo {
		width: 100%;
		margin-bottom: 6px;
		text-align: center;
	}

	.BlogManagement-profileViewMainContent-aMtP9 {
		width: 100%;
		text-align: center;
	}
}

/*************** Admin TableNew Design End**************************/

.BlogManagement-ChangeToUpperCase-SV9fl {
	text-transform: uppercase
}

.BlogManagement-noBorder-ECVGn {
	border: 0px !important;
}

/** Admin - Common - End **/

/* site Admin utility Start */

.BlogManagement-siteAdminHeading-AXNOy {
	font-size: 24px;
	line-height: 32px;
	font-weight: 700;
	margin: 0 0 24px;
	text-align: start;
	color: var(--primary-foreground);
}

.BlogManagement-siteAdminSubHeading-CTQPq {
	font-size: 18px;
	line-height: 26px;
	font-weight: 600;
	margin: 0 0 12px;
	text-align: start;
	color: var(--primary-foreground);
}

.BlogManagement-adminFormDivider-dg49V {
	border-top: 1px solid var(--primary-border);
	margin-bottom: 24px;
}

.BlogManagement-errorMessage-qOlxh {
  margin: 5px 0px;
  display: block;
  color: var(--alert-color);
  font-size: 14px;
  font-weight: normal;
}

.BlogManagement-panelHeader-g7qhx {
  border-radius: 0;
  width: 100%;
  display: block;
  font-size: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid var(--primary-border);
}

.BlogManagement-formGroup-Eqk87 {
  margin-bottom: 6px;
}

.BlogManagement-select-j6p5E {
  position: relative;
  display: inline-block;
  vertical-align: bottom;
  margin-right: 5px;
}

.BlogManagement-labelText-OFHtP {
  font-size: 14px;
  color: var(--secondary-foreground);
  margin: 6px 0px;
  line-height: 1.43;
  font-weight: normal;
  vertical-align: middle;
}

.BlogManagement-space1-Elkd7 {
	margin-bottom: 6px !important;
}

.BlogManagement-space2-YaGbg {
	margin-bottom: 12px !important;
}

.BlogManagement-space3-giD4V {
	margin-bottom: 18px !important;
}

.BlogManagement-space4-Dl7CZ {
	margin-bottom: 24px !important;
}

.BlogManagement-space5-Opu0m {
	margin-bottom: 30px !important;
}

.BlogManagement-space6-NbZIG {
	margin-bottom: 36px !important;
}

.BlogManagement-space7-orXL6 {
	margin-bottom: 42px !important;
}

.BlogManagement-spaceTop8-V23Z5 {
	margin-bottom: 48px !important;
}

.BlogManagement-spaceTop1-NnKFE {
	margin-top: 6px !important;
}

.BlogManagement-spaceTop2-tVjMX {
	margin-top: 12px !important;
}

.BlogManagement-spaceTop3-y2z6y {
	margin-top: 18px !important;
}

.BlogManagement-spaceTop4-OHBbX {
	margin-top: 24px !important;
}

.BlogManagement-spaceTop5-zKM7l {
	margin-top: 30px !important;
}

.BlogManagement-spaceTop6-hEjaY {
	margin-top: 36px !important;
}

.BlogManagement-spaceTop7-wpt2y {
	margin-top: 42px !important;
}

.BlogManagement-spaceTop8-V23Z5 {
	margin-top: 48px !important;
}

.BlogManagement-noMargin-PKzzq {
	margin: 0px !important;
}

.BlogManagement-padding1-L0HGS {
	padding-bottom: 6px !important;
}

.BlogManagement-padding2-nV89L {
	padding-bottom: 12px !important;
}

.BlogManagement-padding3-VVNDp {
	padding-bottom: 18px !important;
}

.BlogManagement-padding4-M8M3_ {
	padding-bottom: 24px !important;
}

.BlogManagement-padding5-Dn3Uj {
	padding-bottom: 30px !important;
}

.BlogManagement-padding6-gYdWY {
	padding-bottom: 36px !important;
}

.BlogManagement-padding7-aTxZ3 {
	padding-bottom: 42px !important;
}

.BlogManagement-paddingTop1-KsB2b {
	padding-top: 6px !important;
}

.BlogManagement-paddingTop2-ApuVC {
	padding-top: 12px !important;
}

.BlogManagement-paddingTop3-CAg8l {
	padding-top: 18px !important;
}

.BlogManagement-paddingTop4-NCESe {
	padding-top: 24px !important;
}

.BlogManagement-paddingTop5-GhyJU {
	padding-top: 30px !important;
}

.BlogManagement-paddingTop6-oQ_q2 {
	padding-top: 36px !important;
}

.BlogManagement-paddingTop7-ghAza {
	padding-top: 42px !important;
}

.BlogManagement-noPadding-kUx4d {
	padding: 0px !important;
}

.BlogManagement-textBold-BfFO_ {
	font-weight: 500 !important;
}

.BlogManagement-textBolder-vbowR {
	font-weight: 700 !important;
}

.BlogManagement-textNormal-V6jhH {
	font-weight: normal !important;
}

.BlogManagement-spaceBottom20-aK8IC {
	margin-bottom: 20px;
}

.BlogManagement-spaceBottom10-i8Ufp {
	margin-bottom: 10px;
}

.BlogManagement-marginNone-Ig8ku {
	margin: 0;
}

.BlogManagement-spaceBottom15-CVSGo {
	margin-bottom: 15px;
}

.BlogManagement-marginTopNone-NSLvM {
	margin-top: 0;
}

.BlogManagement-spaceTop11-EijrU {
	margin-top: 11px;
}

.BlogManagement-spaceTop21-PqWoz {
	margin-top: 21px;
}

.BlogManagement-spaceTop20-cDbgG {
	margin-top: 20px;
}

.BlogManagement-spaceTop10-YapiY {
	margin-top: 10px;
}

/*New Design Text Colors */

.BlogManagement-textDarkBlue-_R1NL {
	color: rgb(20, 39, 94) !important;
}

.BlogManagement-textLightBlue-DIkoQ {
	color: rgb(57, 87, 106) !important;
}

.BlogManagement-textLightSandleGreen-Kzklr {
	color: rgb(76, 86, 41) !important;
}

.BlogManagement-textLightBrown-xTAee {
	color: rgb(115, 79, 33) !important;
}

.BlogManagement-textMediumMaroon-BTKOd {
	color: rgb(87, 37, 51) !important;
}

.BlogManagement-textBrown-Rfkz0 {
	color: rgb(160, 47, 24) !important;
}

.BlogManagement-textMaroon-pV601 {
	color: rgb(155, 49, 67) !important;
}

.BlogManagement-textDarkBrown-LrjsP {
	color: rgb(83, 18, 16) !important;
}

.BlogManagement-textMediumBrown-YT5ki {
	color: rgb(142, 28, 10) !important;
}

.BlogManagement-textSkyBlue-vhd8e {
	color: rgb(37, 117, 141) !important;
}

.BlogManagement-textGray-UrpP0 {
	color: rgb(77, 65, 51) !important;
}`, "",{"version":3,"sources":["webpack://./src/components/siteadmin/newcommonstyle.css","webpack://./src/components/siteadmin/admin-common.css","webpack://./src/components/utils.css","webpack://./src/components/siteadmin/admin-form.css","webpack://./src/components/helpers.css"],"names":[],"mappings":"AAAA;CACC,0BAA0B;AAC3B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,sBAAsB;CACtB,cAAc;CACd,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,+BAA+B;CAC/B,kBAAkB;CAClB,6BAA6B;CAC7B;AACD;;AAEA;CACC,WAAW;CACX,iBAAiB;AAClB;;AAEA;CACC,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,cAAc;CACd,eAAe;AAChB;;AAEA;CACC;EACC,YAAY;CACb;;CAEA;EACC,iBAAiB;CAClB;AACD;;ACpDA,6BAA6B;;AAC7B;CACC,2CAA2C;CAC3C,kBAAkB;CAClB,+DAA+D;AAChE;;AAEA;CACC,gBAAgB;CAChB,WAAW;CACX,cAAc;CACd,eAAe;CACf,oBAAoB;CACpB,8CAA8C;CAC9C,2CAA2C;AAC5C;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,qBAAqB;CACrB,sBAAsB;CACtB,iBAAiB;AAClB;;AAEA;CACC,WAAW;AACZ;;AAEA;;CAEC,eAAe;AAChB;;AAEA;CACC,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,eAAe;CACf,iBAAiB;CACjB,gCAAgC;AACjC;;AAEA;CACC,qBAAqB;AACtB;;AAEA,sEAAsE;;AAEtE;CACC,qBAAqB;AACtB;;AAEA;CACC,qBAAqB;CACrB,iBAAiB;AAClB;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,sBAAsB;AACvB;;AAEA;CACC,gBAAgB;CAChB,+BAA+B;CAC/B,sBAAsB;AACvB;;AAEA;CACC;EACC,cAAc;EACd,mBAAmB;CACpB;;CAEA;EACC,cAAc;EACd,gBAAgB;CACjB;;CAEA;EACC,WAAW;CACZ;AACD;;AAEA,sEAAsE;;AAEtE,sEAAsE;;AAEtE;CACC,gBAAgB;CAChB,4BAA4B;CAC5B,wBAAwB;CACxB,kBAAkB;CAClB,2BAA2B;CAC3B,0CAA0C;CAC1C,wCAAwC;AACzC;;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,UAAU;AACX;;AAEA,4DAA4D;;AAE5D;CACC,aAAa;AACd;;AAEA;CACC,0CAA0C;CAC1C,+BAA+B;CAC/B,gCAAgC;AACjC;;AAEA;CACC,YAAY;AACb;;AAEA,sEAAsE;;AAEtE;CACC,mBAAmB;CACnB,kBAAkB;CAClB,aAAa;CACb,kCAAkC;CAClC,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,cAAc;CACd,2BAA2B;CAC3B,4BAA4B;CAC5B,uCAAuC;CACvC,gBAAgB;AACjB;;AAEA;CACC,yCAAyC;AAC1C;;AAEA;CACC,2CAA2C;CAC3C,gCAAgC;CAChC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,SAAS;AACV;;AAEA;CACC,0CAA0C;CAC1C,aAAa;CACb,kBAAkB;CAClB,qBAAqB;AACtB;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,WAAW;CACX,eAAe;CACf,sBAAsB;AACvB;;AAEA;CACC,qBAAqB;CACrB;AACD;;AAEA;CACC,qBAAqB;CACrB,UAAU;AACX;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;AACnB;;AAEA;CACC,aAAa;CACb,8CAA8C;AAC/C;;AAEA;CACC,WAAW;CACX,aAAa;CACb,gBAAgB;CAChB,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,aAAa;CACb,8BAA8B;CAC9B,wBAAgB;IAAhB,qBAAgB;SAAhB,gBAAgB;CAChB,qBAAqB;AACtB;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,yBAAyB;CACzB,eAAe;CACf,6BAA6B;CAC7B,8BAA8B;CAC9B,yCAAyC;AAC1C;;AAEA;CACC,2CAA2C;CAC3C,cAAc;AACf;;AAEA;CACC,eAAe;CACf,eAAe;CACf,kCAAkC;AACnC;;AAEA;CACC;EACC,YAAY;EACZ,cAAc;CACf;AACD;;AAEA;CACC;EACC,cAAc;CACf;AACD;;AAEA;CACC;EACC,2BAA2B;CAC5B;;CAEA;EACC,sCAAsC;CACvC;;AAED;;AAEA;CACC;EACC,WAAW;EACX,kBAAkB;EAClB,kBAAkB;CACnB;;CAEA;EACC,WAAW;EACX,kBAAkB;CACnB;AACD;;AAEA,oEAAoE;;AAEpE;CACC;AACD;;AAEA;CACC,sBAAsB;AACvB;;AAEA,2BAA2B;;AAE3B,6BAA6B;;AAC7B;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,gBAAgB;CAChB,iBAAiB;CACjB,gCAAgC;AACjC;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,gBAAgB;CAChB,iBAAiB;CACjB,gCAAgC;AACjC;;AAEA;CACC,2CAA2C;CAC3C,mBAAmB;AACpB;;ACvUA;EACE,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,mBAAmB;AACrB;;ACJA;EACE,gBAAgB;EAChB,WAAW;EACX,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;AACxB;;AC7BA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,SAAS;AACV;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA,0BAA0B;;AAE1B;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,iCAAiC;AAClC","sourcesContent":[".commonHeaderAdmin {\n\tposition: fixed !important;\n}\n\n.adminLayout {\n\tpadding-top: 64px !important;\n}\n\n.box h2 {\n\tfont-size: 21px;\n\tfont-weight: 600;\n}\n\n.exportLink {\n\tmargin-bottom: -29px;\n}\n\n.blockCenter {\n\tfloat: none !important;\n\tdisplay: block;\n\tmargin: 0 auto;\n\tmargin-top: 30px;\n}\n\n.panelHeader {\n\tpadding-bottom: 18px !important;\n\tpadding: 24px 15px;\n\tborder-radius: 6px !important;\n\tborder: 1px solid var(--primary-border)\n}\n\n.currencyselect {\n\twidth: 100%;\n\tmargin-right: 0px;\n}\n\n.panelHeader {\n\toverflow: hidden;\n\tposition: relative;\n}\n\n.mar0 {\n\tmargin-left: 0;\n\tmargin-right: 0;\n}\n\n@media screen and (max-width: 767px) {\n\t.blockCenter {\n\t\tpadding: 0px;\n\t}\n\n\t.panelHeader {\n\t\tpadding: 24px 5px;\n\t}\n}","@import './newcommonstyle.css';\n\n/** Admin - Common - Start **/\n.sideAdminPageWrapper {\n\tmargin-left: var(--siteAdmin-sideBar-width);\n\tposition: relative;\n\tpadding: calc(var(--siteAdmin-header-height) + 28px) 25px 120px;\n}\n\n.panelHeader {\n\tborder-radius: 0;\n\twidth: 100%;\n\tdisplay: block;\n\tfont-size: 16px;\n\tpadding-bottom: 12px;\n\tborder-bottom: 1px solid var(--primary-border);\n\tbackground-color: var(--background-primary);\n}\n\n.table {\n\tdisplay: table;\n}\n\n.tableRow {\n\tdisplay: table-row;\n}\n\n.tableCell {\n\tdisplay: table-cell;\n\tfloat: none;\n}\n\n.formGroup {\n\tmargin-bottom: 6px;\n}\n\n.select {\n\tposition: relative;\n\tdisplay: inline-block;\n\tvertical-align: bottom;\n\tmargin-right: 5px;\n}\n\n.noMargin {\n\tmargin: 0px;\n}\n\na,\na:hover {\n\tcursor: pointer;\n}\n\n.exportLink {\n\tpadding-top: 10px;\n\tpadding-right: 10px;\n}\n\n.labelTextNew {\n\tfont-size: 16px;\n\tline-height: 24px;\n\tfont-weight: 600;\n\tmargin: 0 0 6px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.displayInline {\n\tdisplay: inline-block;\n}\n\n/******************* Admin Modal ListSetting Start *******************/\n\n.btnUPdate {\n\tdisplay: inline-block;\n}\n\n.btnModalDelete {\n\tdisplay: inline-block;\n\tmargin-left: 15px;\n}\n\n.radioBtn {\n\tposition: relative;\n\ttop: 1px;\n\tvertical-align: middle;\n}\n\n.backgroundImg {\n\tpadding-top: 80%;\n\tbackground-position: top center;\n\tbackground-size: cover;\n}\n\n@media screen and (max-width: 767px) {\n\t.btnUPdate {\n\t\tdisplay: block;\n\t\tmargin-bottom: 12px;\n\t}\n\n\t.btnModalDelete {\n\t\tdisplay: block;\n\t\tmargin-left: 0px;\n\t}\n\n\t.btnWidth {\n\t\twidth: 100%;\n\t}\n}\n\n/******************* Admin Modal ListSetting Start *******************/\n\n/******************* Admin Banner Image Section Start ****************/\n\n.bannerImageBg {\n\tpadding-top: 60%;\n\tbackground-repeat: no-repeat;\n\tbackground-size: contain;\n\tborder-radius: 4px;\n\tbackground-position: center;\n\tbackground-color: var(--secondary-gray-bg);\n\tborder: 1px dashed var(--primary-border);\n}\n\n.bannerDelete {\n\tposition: absolute;\n\ttop: -12px;\n\tright: 4px;\n}\n\n/*******************Admin Modal Start **********************/\n\n.modalRoot {\n\tpadding: 32px;\n}\n\n.modalBorderBottom {\n\tborder-bottom: 5px solid var(--primary-bg);\n\tborder-bottom-left-radius: 14px;\n\tborder-bottom-right-radius: 14px;\n}\n\n.logInModalBody {\n\tpadding: 0px;\n}\n\n/*************** Admin TableNew Design Start**************************/\n\n.exportSection {\n\tbackground: #f5f5f5;\n\tpadding: 24px 15px;\n\tdisplay: grid;\n\tgrid-template-columns: 28% 15% 55%;\n\talign-items: center;\n\tgrid-gap: 11px;\n\tborder-top-left-radius: 6px;\n\tborder-top-right-radius: 6px;\n\tborder: 1px solid var(--primary-border);\n\tborder-bottom: 0;\n}\n\n.exportSectionGridSub {\n\tgrid-template-columns: 50% 49% !important;\n}\n\n.exportText {\n\tcolor: var(--primary-foreground) !important;\n\ttext-decoration: none !important;\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 12px;\n}\n\n.exportLinkImg {\n\tbackground: var(--common-white-primary-bg);\n\tpadding: 10px;\n\tborder-radius: 4px;\n\tdisplay: inline-block;\n}\n\n.vtrMiddle {\n\tvertical-align: middle;\n}\n\n.exportImg {\n\twidth: 100%;\n\tmax-width: 16px;\n\tvertical-align: middle;\n}\n\n.profileViewlabel {\n\tdisplay: inline-block;\n\twidth: 38%\n}\n\n.profileViewMainContent {\n\tdisplay: inline-block;\n\twidth: 62%;\n}\n\n.profileViewMain {\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 6px;\n}\n\n.profileViewInner {\n\tpadding: 10px;\n\tborder-bottom: 1px solid var(--primary-border);\n}\n\n.profileImageSection {\n\twidth: 100%;\n\theight: 100px;\n\tmax-width: 100px;\n\tmax-height: 100px;\n\tborder-radius: 50%;\n}\n\n.lastviewInner {\n\tpadding: 10px;\n}\n\n.whyHostHoriLine {\n\tmargin: 30px 0;\n}\n\n.tableGrid {\n\tdisplay: grid;\n\tgrid-template-columns: 50% 50%;\n\tcolumn-gap: 10px;\n\tword-wrap: break-word;\n}\n\n.headingContent {\n\tfont-size: 18px;\n\tfont-weight: 500;\n}\n\n.refundTextColor {\n\tcolor: var(--alert-color);\n\tfont-size: 18px;\n\ttext-decoration: line-through;\n\ttext-decoration-thickness: 2px;\n\ttext-decoration-color: var(--black-color);\n}\n\n.dividerLine {\n\tborder-top: 1px solid var(--primary-border);\n\tmargin: 30px 0;\n}\n\n.smallContent {\n\tfont-size: 14px;\n\tmargin-top: 6px;\n\tcolor: var(--secondary-foreground);\n}\n\n@media (max-width: 1200px) and (min-width: 1024px) {\n\t.sideAdminPageWrapper {\n\t\theight: 100%;\n\t\toverflow: auto;\n\t}\n}\n\n@media (max-width:1199px) {\n\t.sideAdminPageWrapper {\n\t\tmargin-left: 0;\n\t}\n}\n\n@media screen and (max-width: 991px) {\n\t.exportSection {\n\t\tgrid-template-columns: 100%;\n\t}\n\n\t.exportSectionGridSub {\n\t\tgrid-template-columns: 100% !important;\n\t}\n\n}\n\n@media screen and (max-width: 767px) {\n\t.profileViewlabel {\n\t\twidth: 100%;\n\t\tmargin-bottom: 6px;\n\t\ttext-align: center;\n\t}\n\n\t.profileViewMainContent {\n\t\twidth: 100%;\n\t\ttext-align: center;\n\t}\n}\n\n/*************** Admin TableNew Design End**************************/\n\n.ChangeToUpperCase {\n\ttext-transform: uppercase\n}\n\n.noBorder {\n\tborder: 0px !important;\n}\n\n/** Admin - Common - End **/\n\n/* site Admin utility Start */\n.siteAdminHeading {\n\tfont-size: 24px;\n\tline-height: 32px;\n\tfont-weight: 700;\n\tmargin: 0 0 24px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.siteAdminSubHeading {\n\tfont-size: 18px;\n\tline-height: 26px;\n\tfont-weight: 600;\n\tmargin: 0 0 12px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.adminFormDivider {\n\tborder-top: 1px solid var(--primary-border);\n\tmargin-bottom: 24px;\n}",".errorMessage {\n  margin: 5px 0px;\n  display: block;\n  color: var(--alert-color);\n  font-size: 14px;\n  font-weight: normal;\n}","@import '../utils.css';\n\n.panelHeader {\n  border-radius: 0;\n  width: 100%;\n  display: block;\n  font-size: 16px;\n  padding-bottom: 12px;\n  border-bottom: 1px solid var(--primary-border);\n}\n\n.formGroup {\n  margin-bottom: 6px;\n}\n\n.select {\n  position: relative;\n  display: inline-block;\n  vertical-align: bottom;\n  margin-right: 5px;\n}\n\n.labelText {\n  font-size: 14px;\n  color: var(--secondary-foreground);\n  margin: 6px 0px;\n  line-height: 1.43;\n  font-weight: normal;\n  vertical-align: middle;\n}",".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n.spaceBottom20 {\n\tmargin-bottom: 20px;\n}\n\n.spaceBottom10 {\n\tmargin-bottom: 10px;\n}\n\n.marginNone {\n\tmargin: 0;\n}\n\n.spaceBottom15 {\n\tmargin-bottom: 15px;\n}\n\n.marginTopNone {\n\tmargin-top: 0;\n}\n\n.spaceTop11 {\n\tmargin-top: 11px;\n}\n\n.spaceTop21 {\n\tmargin-top: 21px;\n}\n\n.spaceTop20 {\n\tmargin-top: 20px;\n}\n\n.spaceTop10 {\n\tmargin-top: 10px;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"commonHeaderAdmin": `BlogManagement-commonHeaderAdmin-cg6N1`,
	"adminLayout": `BlogManagement-adminLayout-rsfF2`,
	"box": `BlogManagement-box-dmdhz`,
	"exportLink": `BlogManagement-exportLink-D252l`,
	"blockCenter": `BlogManagement-blockCenter-Vstan`,
	"panelHeader": `BlogManagement-panelHeader-g7qhx`,
	"currencyselect": `BlogManagement-currencyselect-ae6MZ`,
	"mar0": `BlogManagement-mar0-ZKXQO`,
	"sideAdminPageWrapper": `BlogManagement-sideAdminPageWrapper-iXdOf`,
	"table": `BlogManagement-table-S4ka6`,
	"tableRow": `BlogManagement-tableRow-zByaq`,
	"tableCell": `BlogManagement-tableCell-L1TW7`,
	"formGroup": `BlogManagement-formGroup-Eqk87`,
	"select": `BlogManagement-select-j6p5E`,
	"noMargin": `BlogManagement-noMargin-PKzzq`,
	"labelTextNew": `BlogManagement-labelTextNew-fZLEj`,
	"displayInline": `BlogManagement-displayInline-v5VwX`,
	"btnUPdate": `BlogManagement-btnUPdate-TUFq1`,
	"btnModalDelete": `BlogManagement-btnModalDelete-OI4Yb`,
	"radioBtn": `BlogManagement-radioBtn-m_0S3`,
	"backgroundImg": `BlogManagement-backgroundImg-ewwsT`,
	"btnWidth": `BlogManagement-btnWidth-e3cTO`,
	"bannerImageBg": `BlogManagement-bannerImageBg-UmfJG`,
	"bannerDelete": `BlogManagement-bannerDelete-Bw3hY`,
	"modalRoot": `BlogManagement-modalRoot-aEmvV`,
	"modalBorderBottom": `BlogManagement-modalBorderBottom-AsyGm`,
	"logInModalBody": `BlogManagement-logInModalBody-bLt3w`,
	"exportSection": `BlogManagement-exportSection-lgEAS`,
	"exportSectionGridSub": `BlogManagement-exportSectionGridSub-bXJ7G`,
	"exportText": `BlogManagement-exportText-e7WzP`,
	"exportLinkImg": `BlogManagement-exportLinkImg-CTWoA`,
	"vtrMiddle": `BlogManagement-vtrMiddle-GjkL2`,
	"exportImg": `BlogManagement-exportImg-ChsSB`,
	"profileViewlabel": `BlogManagement-profileViewlabel-QKdfo`,
	"profileViewMainContent": `BlogManagement-profileViewMainContent-aMtP9`,
	"profileViewMain": `BlogManagement-profileViewMain-PjaA6`,
	"profileViewInner": `BlogManagement-profileViewInner-HS_Qv`,
	"profileImageSection": `BlogManagement-profileImageSection-hc6fg`,
	"lastviewInner": `BlogManagement-lastviewInner-Q5528`,
	"whyHostHoriLine": `BlogManagement-whyHostHoriLine-ewnKq`,
	"tableGrid": `BlogManagement-tableGrid-a7b4d`,
	"headingContent": `BlogManagement-headingContent-Uwkmv`,
	"refundTextColor": `BlogManagement-refundTextColor-YbtVa`,
	"dividerLine": `BlogManagement-dividerLine-P7UFL`,
	"smallContent": `BlogManagement-smallContent-inHtx`,
	"ChangeToUpperCase": `BlogManagement-ChangeToUpperCase-SV9fl`,
	"noBorder": `BlogManagement-noBorder-ECVGn`,
	"siteAdminHeading": `BlogManagement-siteAdminHeading-AXNOy`,
	"siteAdminSubHeading": `BlogManagement-siteAdminSubHeading-CTQPq`,
	"adminFormDivider": `BlogManagement-adminFormDivider-dg49V`,
	"errorMessage": `BlogManagement-errorMessage-qOlxh`,
	"labelText": `BlogManagement-labelText-OFHtP`,
	"space1": `BlogManagement-space1-Elkd7`,
	"space2": `BlogManagement-space2-YaGbg`,
	"space3": `BlogManagement-space3-giD4V`,
	"space4": `BlogManagement-space4-Dl7CZ`,
	"space5": `BlogManagement-space5-Opu0m`,
	"space6": `BlogManagement-space6-NbZIG`,
	"space7": `BlogManagement-space7-orXL6`,
	"spaceTop8": `BlogManagement-spaceTop8-V23Z5`,
	"spaceTop1": `BlogManagement-spaceTop1-NnKFE`,
	"spaceTop2": `BlogManagement-spaceTop2-tVjMX`,
	"spaceTop3": `BlogManagement-spaceTop3-y2z6y`,
	"spaceTop4": `BlogManagement-spaceTop4-OHBbX`,
	"spaceTop5": `BlogManagement-spaceTop5-zKM7l`,
	"spaceTop6": `BlogManagement-spaceTop6-hEjaY`,
	"spaceTop7": `BlogManagement-spaceTop7-wpt2y`,
	"padding1": `BlogManagement-padding1-L0HGS`,
	"padding2": `BlogManagement-padding2-nV89L`,
	"padding3": `BlogManagement-padding3-VVNDp`,
	"padding4": `BlogManagement-padding4-M8M3_`,
	"padding5": `BlogManagement-padding5-Dn3Uj`,
	"padding6": `BlogManagement-padding6-gYdWY`,
	"padding7": `BlogManagement-padding7-aTxZ3`,
	"paddingTop1": `BlogManagement-paddingTop1-KsB2b`,
	"paddingTop2": `BlogManagement-paddingTop2-ApuVC`,
	"paddingTop3": `BlogManagement-paddingTop3-CAg8l`,
	"paddingTop4": `BlogManagement-paddingTop4-NCESe`,
	"paddingTop5": `BlogManagement-paddingTop5-GhyJU`,
	"paddingTop6": `BlogManagement-paddingTop6-oQ_q2`,
	"paddingTop7": `BlogManagement-paddingTop7-ghAza`,
	"noPadding": `BlogManagement-noPadding-kUx4d`,
	"textBold": `BlogManagement-textBold-BfFO_`,
	"textBolder": `BlogManagement-textBolder-vbowR`,
	"textNormal": `BlogManagement-textNormal-V6jhH`,
	"spaceBottom20": `BlogManagement-spaceBottom20-aK8IC`,
	"spaceBottom10": `BlogManagement-spaceBottom10-i8Ufp`,
	"marginNone": `BlogManagement-marginNone-Ig8ku`,
	"spaceBottom15": `BlogManagement-spaceBottom15-CVSGo`,
	"marginTopNone": `BlogManagement-marginTopNone-NSLvM`,
	"spaceTop11": `BlogManagement-spaceTop11-EijrU`,
	"spaceTop21": `BlogManagement-spaceTop21-PqWoz`,
	"spaceTop20": `BlogManagement-spaceTop20-cDbgG`,
	"spaceTop10": `BlogManagement-spaceTop10-YapiY`,
	"textDarkBlue": `BlogManagement-textDarkBlue-_R1NL`,
	"textLightBlue": `BlogManagement-textLightBlue-DIkoQ`,
	"textLightSandleGreen": `BlogManagement-textLightSandleGreen-Kzklr`,
	"textLightBrown": `BlogManagement-textLightBrown-xTAee`,
	"textMediumMaroon": `BlogManagement-textMediumMaroon-BTKOd`,
	"textBrown": `BlogManagement-textBrown-Rfkz0`,
	"textMaroon": `BlogManagement-textMaroon-pV601`,
	"textDarkBrown": `BlogManagement-textDarkBrown-LrjsP`,
	"textMediumBrown": `BlogManagement-textMediumBrown-YT5ki`,
	"textSkyBlue": `BlogManagement-textSkyBlue-vhd8e`,
	"textGray": `BlogManagement-textGray-UrpP0`
};
module.exports = ___CSS_LOADER_EXPORT___;
